<template>
  <v-container>
    <v-layout column>
      <v-flex>
        <v-layout row wrap>
          <v-flex xs2>
            <h4 class="mt-3 subheading grey--text text--darken-2">タグ名称</h4>
          </v-flex>
          <v-flex xs2 pl-4>
            <h4 class="mt-3 subheading grey--text text--darken-2">保持期間</h4>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-form ref="tag">
          <CampaignModalPageRetargetingListItem
            v-for="(tag, index) in menuSetting.orderDescription.tags"
            :key="index"
            :tag="tag"
            :index="index"
            :canDelete="canDelete"
            @deleteTag="deleteTag($event)"
          />
          <v-btn @click="menuSetting.addTag()" fab color="primary">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CampaignModalPageRetargetingListItem from './CampaignModalPageRetargetingListItem'
export default {
  name: 'CampaignModalPageRetargetingList',
  components: { CampaignModalPageRetargetingListItem },
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    canDelete() {
      return this.menuSetting.isTagsLengthOne
    },
  },
  methods: {
    deleteTag(index) {
      this.menuSetting.deleteTag(index)
    },
    validate() {
      return this.$refs.tag.validate()
    },
  },
}
</script>
